import { DocumentIcon } from "assets/icons";
import Chip from "components/chip/chip";
import { dateExp, dateWordShort } from "helper/helper";
import {useState, useEffect} from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableCell from "./TableCell";
import { useScrollContext } from "./ScrollableTableWrapper";

const Tbodyinvoice = ({ champsBody }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(null);
  const { hasMoved } = useScrollContext();

  // Récupérer l'ID depuis l'URL au chargement
  useEffect(() => {
    const idFromUrl = searchParams.get('selectedId');
    if (idFromUrl) {
      setSelectedId(idFromUrl);
      // Nettoyer l'URL après avoir récupéré l'ID
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('selectedId');
      const newUrl = newParams.toString() ? `?${newParams.toString()}` : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [searchParams]);

  const handleRowClick = (item) => {
    // Empêcher le clic si on vient de faire un drag
    if (hasMoved) {
      return;
    }
    
    setSelectedId(item._id);
    // Naviguer vers la page de détail de la facture avec l'ID pour le retour
    const params = new URLSearchParams({
      id: item._id,
      fileName: item.fileName,
      date: item.date_facture,
      amount: item.amount || '',
      status: item.status ? 'true' : 'false',
      returnId: item._id
    });
    navigate(`/invoice/detail?${params.toString()}`);
  };

  return (
    <>
      {champsBody?.slice().reverse().map((item) => {
        const isSelected = selectedId === item._id;
        return (
        <tr 
          key={item._id} 
          className={`${isSelected ? 'bg-yellow-50' : 'hover:bg-gray-50'} cursor-pointer transition-colors`}
          onClick={() => handleRowClick(item)}
        >
          {/*Mois*/}
          <td className={"uppercase py-5 pl-4 pr-2 min-w-[150px]"}>{dateExp(item.date_facture)}</td>
          {/*Montant*/}
          <td className={"py-5 px-2 min-w-[120px]"}>{item.amount ? `${item.amount} €` : ""} </td>
          {/*Etat*/}
          <td className={"py-5 px-2 min-w-[100px]"}>
            {item.status ? (
              <Chip type={"INDICATOR"} color={"INFO"}>
                Réglé
              </Chip>
            ) : (
              <Chip type={"INDICATOR"} color={"ALERT"}>
                À régler
              </Chip>
            )}
          </td>
          {/*Date*/}
          <td className={"py-5 px-2 min-w-[120px]"}>{dateWordShort(item.date_facture)}</td>
          {/*pdf*/}
          <TableCell
            position="last"
            hasButton
            buttonOnClick={(e) => {
              e.stopPropagation();
              const params = new URLSearchParams({
                id: item._id,
                fileName: item.fileName,
                date: item.date_facture,
                amount: item.amount || '',
                status: item.status ? 'true' : 'false',
                returnId: item._id
              });
              navigate(`/invoice/detail?${params.toString()}`);
            }}
            buttonContent={<DocumentIcon wh={24} color={"#111827"} />}
          />
        </tr>
        );
      })}
    </>
  );
};

export default Tbodyinvoice;
